import { useEffect, useState } from "react";
import { collection, getFirestore, onSnapshot, query, orderBy } from "firebase/firestore";
import { BiSearch } from "react-icons/bi";
import { Table } from "react-bootstrap";
import PaymentRow from "./components/paymentRow";

export default function Payments() {


    const db = getFirestore();
    const [search, setSearch] = useState("");
    const [transactions, setTransactions] = useState([]);


    const handleSearchChange = (e) => {
        setSearch(e.target.value.trim());
        console.log(e.target.value);
    }



    useEffect(
        async () => {
            const q = query(collection(db, "transactions"), orderBy("createdAt", "desc"));
            var tempList = [];
            const unsubscribe = onSnapshot(q, (querySnapshot) => {

                querySnapshot.forEach((doc) => {
                    let data = doc.data();
                    if (
                        data["to"].toString().toLowerCase().includes(search.trim().toLowerCase())
                        || data["from"].toString().toLowerCase().includes(search.trim().toLowerCase())
                        || data["message"].toString().toLowerCase().includes(search.trim().toLowerCase())

                    ) {
                        tempList.push(data);
                    }
                });


                setTransactions([...tempList]);
            });



            return function cleanup() {
                unsubscribe();
            };
        },
        [search]
    );






    // return (
    //     <div className="relative bg-transparent w-full h-full">

    //         <div className="relative h-full w-full p-10 flex justify-start items-start flex-col">

    //             <div className="text-white font-bold rounded-sm text-3xl mb-5">Payments</div>

    //             <div className="flex flex-row w-2/4 bg-white mb-10 ">
    //                 <input
    //                     onChange={(e) => { handleSearchChange(e) }}
    //                     placeholder="Search"
    //                     className="w-11/12 p-3 text-black bg-white border-0 outline-0 shadow-xl" />

    //                 <div className="w-1/12 flex justify-center items-center">
    //                     <BiSearch size={40} color={"black"} />
    //                 </div>
    //             </div>

    //             <div className="w-full" >
    //                 <Table bordered className="text-white table-fixed">

    //                     <thead>
    //                         <tr className="w-full">
    //                             <th>
    //                                 <div className="flex justify-center">
    //                                     Amount
    //                                 </div>
    //                             </th>
    //                             <th>
    //                                 <div className="flex justify-center">
    //                                     Message
    //                                 </div>
    //                             </th>
    //                             <th>
    //                                 <div className="flex justify-center">
    //                                     from
    //                                 </div>
    //                             </th>
    //                             <th>
    //                                 <div className="flex justify-center">
    //                                     to
    //                                 </div>
    //                             </th>
    //                             <th>
    //                                 <div className="flex justify-center">
    //                                     Date
    //                                 </div>
    //                             </th>


    //                         </tr>
    //                     </thead>



    //                     <tbody>
    //                         {
    //                             transactions.map(
    //                                 (transactionsData, transactionIndex) => {
    //                                     return (
    //                                         <PaymentRow key={transactionsData["createdAt"]} data={transactionsData} />
    //                                     )
    //                                 }
    //                             )
    //                         }
    //                     </tbody>


    //                 </Table>
    //             </div>



    //         </div>

    //     </div>
    // )


   

}
